import { useFeatureToggle } from 'hooks'
import { ProjectViewContent as ProjectViewContentLegacy } from './ProjectViewContent'
import { ProjectViewContentArc } from './ProjectViewContentArc'

export const ProjectViewContent = () => {
  const arcNewProjectEnabled = useFeatureToggle('arc-mosaico-project')

  if (arcNewProjectEnabled) {
    return <ProjectViewContentArc />
  }

  return <ProjectViewContentLegacy />
}
